import { forEach } from "lodash";
import { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { useGetOrderById } from "src/app/hooks";
import { IActionsModal } from "src/app/types/actionsModal";
import { ImageContent } from "src/app/types/content";
import { Order } from "src/app/types/orders/order";
import { checkLink, linksPassTest } from "src/app/utils/stringHelper";

const ViewTextToCopyContainer = (props: IActionsModal<Order>) => {
    const { handleClose = () => {}, entity } = props;
    const { formatMessage } = useIntl();

    const [titleImage, setTitleImage] = useState<Array<ImageContent>>([]);
    const [doc, setDoc] = useState<Document>();
    const [linksTestPassed, setLinksTestPassed] = useState<boolean>();

    const { order, loading } = useGetOrderById(entity?.id);

    useEffect(() => {
        if (!order) return;
        const images = order?.content?.images;
        const links = order?.links;
        const text = order?.content?.text;
        const titleImageAux: ImageContent[] = [];
        const parser = new DOMParser();
        const docAux = parser.parseFromString(text || "", "text/html");
        const checkLinks = checkLink(text || "", links);
        setLinksTestPassed(linksPassTest(checkLinks, links));

        forEach(images, (img) => {
            const image = document.createElement("img");
            image.src = img.largeImageUrl;
            image.style.width = "900px";
            image.style.aspectRatio = "2/1";
            let found = false;

            const h2s = docAux?.getElementsByTagName("h2");
            forEach(h2s, (h2) => {
                if (h2.innerText === img.position) {
                    h2.parentNode?.insertBefore(image, h2.previousSibling);
                    found = true;
                    return;
                }
            });
            if (found) return;

            const h3s = docAux?.getElementsByTagName("h3");
            forEach(h3s, (h3) => {
                if (h3.innerText === img.position) {
                    h3.parentNode?.insertBefore(image, h3.previousSibling);
                    found = true;
                    return;
                }
            });
            if (!found) titleImageAux.push(img);
        });
        setDoc(docAux);
        setTitleImage(titleImageAux);
    }, [order]);

    function toClipboard(elementId: string) {
        const element = document.getElementById(elementId) as Node;
        let range;
        let selection;

        if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(element);
            selection?.removeAllRanges();
            selection?.addRange(range);
            document.execCommand("copy");
            window?.getSelection()?.removeAllRanges();
            toast.success(`${formatMessage({ id: "common.action.copied" })}`);
        }
    }

    const FooterLeftComponent = (
        <div>
            <Button onClick={() => toClipboard("toBeCopy")}>Copy</Button>
        </div>
    );

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.viewText" })}
            buttonConfirmationAction={() => handleClose()}
            buttonConfirmationLabel={formatMessage({ id: "common.action.ok" })}
            handleClose={handleClose}
            loading={loading}
            formId="viewTextForm"
            FooterLeftComponent={FooterLeftComponent}
            showModal={true}
            modalProps={{ fullscreen: true }}
        >
            <>
                {!doc ? (
                    <></>
                ) : (
                    <Container id="toBeCopy" style={{ width: "900px" }}>
                        <div>
                            <b>MT: </b> {` ${order?.content?.metaTitle}`}
                        </div>
                        <div>
                            <b>MD: </b> {` ${order?.content?.metaDescription}`}
                        </div>
                        <br />

                        {!linksTestPassed && (
                            <div style={{ border: "2px solid red", padding: "8px" }}>
                                <h2 style={{ color: "red", textAlign: "center" }}>
                                    {formatMessage({ id: "common.field.warning" }).toUpperCase()}
                                </h2>
                                <h3 style={{ color: "red", textAlign: "center" }}>
                                    {formatMessage({
                                        id: "common.field.warning.badLink",
                                    }).toUpperCase()}
                                </h3>
                            </div>
                        )}
                        <>
                            <h1>{order?.content?.title}</h1>
                        </>
                        {titleImage &&
                            titleImage.map((img, index) => (
                                <img
                                    key={index}
                                    style={{ width: "840px", aspectRatio: "2/1" }}
                                    src={img.largeImageUrl}
                                />
                            ))}
                        <>
                            <div
                                className="viewTextToCopyWrapper"
                                dangerouslySetInnerHTML={{
                                    __html: doc.documentElement.outerHTML || "",
                                }}
                            ></div>
                        </>
                    </Container>
                )}
            </>
        </SimpleModal>
    );
};

export default ViewTextToCopyContainer;
